import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-2"
}

import { PlusIcon } from 'lucide-vue-next';
import { ref, onMounted, onUnmounted } from 'vue';

// Responsive detection

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterButton',
  setup(__props) {

const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: _normalizeClass([
      isMobile.value ? 
        'fixed bottom-20 right-6 rounded-full w-14 h-14 bg-emerald-500 shadow-md z-50 flex items-center justify-center' : 
        'rounded-xl bg-emerald-500 px-8 py-3 font-semibold text-sm'
    ])
  }, [
    (!isMobile.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_unref(PlusIcon), { class: "h-5 w-5 hidden 2xl:block" }),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createBlock(_unref(PlusIcon), {
          key: 1,
          class: "h-7 w-7"
        }))
  ], 2))
}
}

})